module.exports = __webpack_public_path__ + "img/img_promotion_bnr_hello.b223a9bc.png";